// extracted by mini-css-extract-plugin
module.exports = {"price":"PaymentText_price__9kRL9","disabled":"PaymentText_disabled__UmCVn","ml_10px":"PaymentText_ml_10px__IfngJ","mt_8px":"PaymentText_mt_8px__GO8Qp"};